// Helpers puros del bracket de eliminatoria. No tocan la BD.

// Orden de semillas para un bracket de tamaño P (potencia de 2). Pares consecutivos =
// llaves. P=4 -> [1,4,2,3] (llaves 1-4, 2-3). P=8 -> [1,8,4,5,2,7,3,6].
export function bracketSeedOrder(P) {
  let r = [1, 2];
  while (r.length < P) {
    const m = r.length * 2 + 1;
    const nx = [];
    r.forEach((s) => { nx.push(s); nx.push(m - s); });
    r = nx;
  }
  return r;
}

// Menor potencia de 2 mayor o igual a n (mínimo 2).
export function proximaPotencia2(n) {
  let p = 2;
  while (p < n) p *= 2;
  return p;
}

// Clasificados ordenados por semilla desde las tablas de grupo.
// porGrupo = { A: [insc1º, insc2º, ...], B: [...] } (ya ordenados por posición).
// Semilla = índice (0 = mejor): todos los 1º (por letra de grupo), luego los 2º, etc.
export function sembrarClasificados(porGrupo = {}, { avanzan = 2 } = {}) {
  const grupos = Object.keys(porGrupo).sort();
  const out = [];
  for (let pos = 0; pos < avanzan; pos++) {
    grupos.forEach((g) => {
      const insc = (porGrupo[g] || [])[pos];
      if (insc) out.push({ inscripcion: insc, grupo: g, pos: pos + 1 });
    });
  }
  return out;
}

const RONDA_NOMBRE = { 2: 'Final', 4: 'Semifinal', 8: 'Cuartos de final', 16: 'Octavos de final', 32: 'Dieciseisavos de final' };
const RONDA_CLAVE = { 2: 'final', 4: 'semifinal', 8: 'cuartos', 16: 'octavos', 32: 'dieciseisavos' };
export function nombreRonda(n) { return RONDA_NOMBRE[n] || `Ronda de ${n}`; }
export function claveRonda(n) { return RONDA_CLAVE[n] || `ronda_${n}`; }
